<!-- components/GlobalLoader.vue -->
<template>
  <div v-if="isLoading" class="global-loader">
    <div class="spinner-border text-light" role="status">
      <span class="visually-hidden">جاري التحميل...</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['isLoading']),
  },
};
</script>

<style>
.global-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
